'use client';

import SizeChart from '@/components/ProductOptions/sizeChart';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import clsx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';

const SizeChartDialog = props => {
  const { isOpen, setIsOpen, isWeddingShoes, shippingType, show_attribute } = props;

  const [showMeasurement, setShowMeasurement] = useState(false);
  const [showVideo, setShowVideo] = useState(false);

  return (
    <Dialog
      open={isOpen}
      onOpenChange={setIsOpen}
    >
      <DialogContent
        showCloseButton={false}
        className='z-[200] mx-auto block h-[100vh] w-screen gap-y-0 overflow-auto border-none px-0 pb-5 pt-0 outline-0 supports-[height:100dvh]_h-[100dvh] lg_h-auto lg_max-h-screen lg_w-[65%] lg_max-w-none lg_p-6 '
      >
        <div className='flex justify-end '>
          <button
            type='button'
            onClick={() => {
              setIsOpen(false);
            }}
            className='flex h-[46px] w-[46px] items-center justify-center'
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='18'
              height='18'
              fill='none'
              viewBox='0 0 18 18'
            >
              <path
                stroke='#80583F'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='1.5'
                d='M17 17 1 1m16 0L1 17'
              ></path>
            </svg>
          </button>
        </div>
        <div className='px-2.5 lg_px-0'>
          <div className=' border-b border-solid border-E7DED5 pb-2.5 font-Shango text-[26px] text-theme'>
            Size Chart
          </div>
        </div>
        {isWeddingShoes ? null : (
          <div className='mt-[35px] flex w-full flex-col gap-x-5 px-2.5 lg_mt-0 lg_flex-row lg_px-0'>
            <button
              type='button'
              onClick={() => {
                setShowMeasurement(x => !x);
              }}
              className='mb-5 flex w-full items-center justify-between border-b-1 border-solid border-aba6a0 py-[14px] pr-2.5 lg_hidden'
            >
              <span className='text-[18px] leading-[1.4]'>MEASUREMENT GUIDE</span>
              <span
                className={clsx(
                  'relative block h-0.5 w-3 bg-80583F',
                  !showMeasurement &&
                    clsx(
                      'before_absolute before_left-1/2 before_top-1/2 before_h-3 before_w-0.5 before_-translate-x-1/2 before_-translate-y-1/2 before_bg-80583F before_content-[""]',
                    ),
                )}
              ></span>
            </button>
            <div className={clsx('w-full flex-1 lg_block lg_basis-[560px]', !showMeasurement && 'hidden')}>
              <h5 className={clsx(' my-4 hidden text-center uppercase text-theme lg_block')}>Measurement Guide</h5>
              <div className={clsx(' lg_flex lg_flex-row-reverse lg_items-start lg_gap-x-3 ')}>
                <Image
                  src={
                    shippingType === 'Dresses'
                      ? `${process.env.NEXT_PUBLIC_BASE_PATH}/product-full-detail/dress.png`
                      : `${process.env.NEXT_PUBLIC_BASE_PATH}/size-chart/measuring-guide-1.svg`
                  }
                  width={256}
                  height={520}
                  alt=''
                  className={clsx(' mx-auto h-auto w-auto flex-none lg_mx-0 lg_w-[190px] ')}
                />

                <div className={clsx('mt-5 lg_mt-0 ', 'flex-1')}>
                  <div>
                    <div className={clsx(' text-base leading-[22px] ', 'text-primary', 'uppercase')}>Bust</div>
                    <p className={clsx(' mt-[5px] ', 'text-[15px] leading-5', 'text-[#666]')}>
                      Wear an unpadded bra (you will be wearing in the dress), and pull tape around the fullest part of
                      the bust and parallel to the floor.
                    </p>
                  </div>

                  <div className={clsx('mt-5 lg_mt-3 ')}>
                    <div className={clsx('  text-base leading-[22px] ', 'text-primary', 'uppercase')}>Waist</div>
                    <p className={clsx(' mt-[5px] ', 'text-[15px] leading-5', 'text-[#666]')}>
                      Find the natural waist, usually about 1 inch(ca. 2.5cm) above the belly button, keep take slightly
                      loose to allow for breathing room.
                    </p>
                  </div>

                  <div className={clsx('mt-5 lg_mt-3')}>
                    <div className={clsx('  text-base leading-[22px] ', 'text-primary', 'uppercase')}>
                      Hip(The Widest Part)
                    </div>
                    <p className={clsx(' mt-[5px] ', 'text-[15px] leading-5', 'text-[#666]')}>
                      Find the widest part of the hip, usually about 8 inches (ca. 20cm) below the natural waist, tape
                      should brush across both hipbones.
                    </p>
                  </div>

                  <div className={clsx('mt-5 lg_mt-3 ')}>
                    <div className={clsx('  text-base leading-[22px] ', 'text-primary', 'uppercase')}>
                      {shippingType === 'Dresses' ? 'HOLLOW TO HEM' : 'HOLLOW TO floor'}(Barefoot)
                    </div>
                    <p className={clsx(' mt-[5px] ', 'text-[15px] leading-5', 'text-[#666]')}>
                      {shippingType === 'Dresses'
                        ? 'Stand up straight with bare feet together and measure from the hollow of your collarbone (the indentation at the base of your neck) to the hem of the dress.'
                        : 'Stand up straight with bare feet together and measure from the hollow of your collarbone (the indentation at the base of your neck) to the hem of the dress.'}
                    </p>
                  </div>

                  <div className={clsx('mt-5 lg_mt-3 ')}>
                    <div className={clsx('  text-base leading-[22px] ', 'text-primary', 'uppercase')}>
                      Height(Barefoot)
                    </div>
                    <p className={clsx(' mt-[5px] ', 'text-[15px] leading-5', 'text-[#666]')}>
                      Stand up straight with barefoot together and measure from the top of the head and pull tape
                      straight down to the floor.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <button
              type='button'
              onClick={() => {
                setShowVideo(x => !x);
              }}
              className={clsx(
                ' flex w-full items-center justify-between border-b-1 border-solid border-aba6a0 py-[14px] pr-2.5 lg_hidden',
                showVideo && 'mb-5',
              )}
            >
              <span className='text-[18px] leading-[1.4]'>WATCH VIDEO</span>
              <span
                className={clsx(
                  'relative block h-0.5 w-3 bg-80583F',
                  !showVideo &&
                    clsx(
                      'before_absolute before_left-1/2 before_top-1/2 before_h-3 before_w-0.5 before_-translate-x-1/2 before_-translate-y-1/2 before_bg-80583F before_content-[""]',
                    ),
                )}
              ></span>
            </button>
            <div className={clsx(' lg_block  lg_basis-[470px]', !showVideo && 'hidden')}>
              <h5 className=' my-4 hidden text-center uppercase text-theme lg_block'>How To Measure</h5>
              <p className='text-left text-sm lg_text-center '>
                <Link
                  className=' text-theme underline'
                  href='/size-chart'
                >
                  Click here
                </Link>
                &nbsp;to learn more size information.
              </p>
              <video
                controls
                muted
                id='sizevedioiframe'
                className=' mt-4 h-[335px] w-[470px]'
                src={`${process.env.NEXT_PUBLIC_BASE_PATH}/media/video/measurevideo.mp4`}
                autoPlay
                title='Size Chart Video'
                poster=''
              >
                <source
                  src={`${process.env.NEXT_PUBLIC_BASE_PATH}/media/video/measurevideo.mp4`}
                  type='video/mp4'
                />
              </video>
            </div>
          </div>
        )}

        <div className=' mt-5 w-full overflow-x-auto px-2.5 lg_px-0'>
          <SizeChart
            sizeLabel='Size'
            sizechartdialog
            showAttribute={show_attribute}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SizeChartDialog;
